import * as a from '@mitranim/js/all.mjs'
import * as c from './general.mjs'

export const BRAND_NAME               = `Core Spirit`
export const BRAND_NAME_ABBR          = `CS`
export const BRAND_SUB_TITLE          = `Is the largest library of ancient esoteric wisdom and modern scientific discovery created to help us to deal with different aspects of our lives.`
export const BRAND_LOGO               = `/images/logo/logo-black.svg`
export const BRAND_FAVICON            = `/images/logo/favicon.svg`
export const BRAND_LOGO_FULL_PATH     = a.url(c.SERVER_ORIGIN).setPath(BRAND_LOGO)
export const START_YEAR = 2015

export const BRAND_SOCIAL_NETWORKS    = {
  Facebook:  `https://facebook.com/corespirit`,
  Twitter:   `https://twitter.com/core_spirit`,
  Instagram: `https://instagram.com/core_spirit`,
  LinkedIn:  `https://linkedin.com/company/core-spirit`,
  Pinterest: `https://pinterest.co.uk/corespirit`,
  YouTube:   `https://www.youtube.com/@corespirit`,
  Telegram:  `https://t.me/core_spirit_platform`,
  // TODO: need to add pages for Core Spirit
  // Discord:   `https://discord.com/corespirit`,
  // Threads:   `https://threads.net/corespirit`,
}

export const BRAND_DOMAIN             = `www.corespirit.com`
export const BRAND_EMAIL_PR           = `pr@corespirit.com`
export const BRAND_EMAIL_CUSTOMER     = `customerservice@corespirit.com`
export const BRAND_EMAIL_ADMIN        = `admin@corespirit.com`
export const BRAND_EMAIL_INFO         = `info@corespirit.com`
export const BRAND_MAILTO_PR          = `mailto:${BRAND_EMAIL_PR}`
export const BRAND_MAILTO_CUSTOMER    = `mailto:${BRAND_EMAIL_CUSTOMER}`
export const BRAND_MAILTO_INFO        = `mailto:${BRAND_EMAIL_INFO}`
export const BRAND_PHONE              = `+447500199003`
export const BRAND_PHONE_WHATS_APP    = `+447387850390`

export const PRIME_SUBSCRIPTION       = `Membership`
export const CS_MEMBERSHIP            = `${BRAND_NAME} ${PRIME_SUBSCRIPTION}`
export const RUS_PRIME                = `Подписка ${BRAND_NAME}`
export const TOTAL_PRACTICES          = `900`
export const TOTAL_PRACTITIONERS      = `15,000`
export const TOTAL_COUNTRIES          = `86`
export const AMOUNT_CHEAPEST_SERVICES = `500+`
export const YOU_RE_SAVING            = `$17,841`
